export default __webpack_public_path__ + "static/media/header-logo.cd4bfc7c.png";